import React from 'react';
import { toast } from "react-toastify";
import i18n from "i18next";

const Msg = ({ title, text }) => (
    <>
        {text && <span>{text}</span>}
    </>
)

const type = { info: toast.TYPE.INFO, success: toast.TYPE.SUCCESS, warning: toast.TYPE.WARNING, error: toast.TYPE.ERROR };

// Forgiving signature so older 2-arg callers (`toastMessage(message, tag)`
// or `toastMessage(tag, message)`) render the message instead of an empty
// toast. The canonical form remains `(tag, title, text)`.
// `options` is passed to react-toastify as is, e.g. { toastId } so a repeated message does not stack.
export const toastMessage = (a, b, c, options) => {
    let tag, title, text;
    if (typeof a === 'string' && type[a] !== undefined && typeof c !== 'undefined') {
        // (tag, title, text) — canonical
        [tag, title, text] = [a, b, c];
    } else if (typeof a === 'string' && type[a] !== undefined && typeof b === 'string' && type[b] === undefined) {
        // (tag, text) — common parking pattern
        [tag, title, text] = [a, undefined, b];
    } else if (typeof b === 'string' && type[b] !== undefined) {
        // (text, tag) — also seen in parking
        [tag, title, text] = [b, undefined, a];
    } else {
        // Best-effort fallback: assume first arg is the message
        [tag, title, text] = ['info', undefined, a];
    }
    toast(<Msg title={title} text={text} />, {
        ...options,
        type: type[tag]
    });
}

export const showAddSuccessToast = () => {
    const successIcon = i18n.t("popupMessages.successIcon");
    const successHeader = i18n.t("popupMessages.success");
    const successMessage = i18n.t("popupMessages.successfullyAdded");

    toastMessage(successIcon, successHeader, successMessage);
}

export const showUpdateSuccessToast = () => {
    const successIcon = i18n.t("popupMessages.successIcon");
    const successHeader = i18n.t("popupMessages.success");
    const successMessage = i18n.t("popupMessages.successfullyUpdated");

    toastMessage(successIcon, successHeader, successMessage);
}

export const showDeleteSuccessToast = () => {
    const successIcon = i18n.t("popupMessages.successIcon");
    const successHeader = i18n.t("popupMessages.success");
    const successMessage = i18n.t("popupMessages.successfullyDeleted");

    toastMessage(successIcon, successHeader, successMessage);
}

export const showEnableDisableSuccessToast = (originalIsActive) => {
    const successIcon = i18n.t("popupMessages.successIcon");
    const successHeader = i18n.t("popupMessages.success");
    const successMessage = originalIsActive === "Yes"
        ? i18n.t("popupMessages.successfullyDisabled")
        : i18n.t("popupMessages.successfullyEnabled");
        
    toastMessage(successIcon, successHeader, successMessage);
}

export const showErrorToast = (errorMessage) => {
    const errorIcon = i18n.t("popupMessages.errorIcon");
    const errorHeader = i18n.t("popupMessages.error");
    
    toastMessage(errorIcon, errorHeader, errorMessage);
}